import { useQuery } from "@tanstack/react-query";
import { listResources } from "@/services/resourcesApi";
import { Resource } from "./types";

export const useResources = () => {
  return useQuery({
    queryKey: ["resources"],
    queryFn: async (): Promise<Resource[]> => {
      const resources = await listResources();
      return resources.map((r) => ({
        id: r.id,
        name: r.name,
        description: r.description,
        created_at: '',
      }));
    },
  });
};
